import React from 'react';

import { DetailTextDisplay } from '@components/admin/Forms';
import { MembershipNameTextDisplay } from '@components/admin/members/MembershipFormDetails/Forms';
import { strings as membershipFormStrings } from '@data/membershipForm';
import Collapse from '@material-ui/core/Collapse';
import { CompanyForm, MembershipFormFields } from '@models/MembershipForm';
import { makeMuiStyles } from '@styles';
import clsx from 'clsx';

const useStyles = makeMuiStyles((theme, common) => ({
  formContainer: {
    ...common.flexColumn,
    marginBottom: '1rem',
  },
  alertDot: {
    height: 10,
    width: 10,
    backgroundColor: theme.palette.error.main,
    marginLeft: 20,
    borderRadius: '50%',
    transform: 'translateY(-1px)',
  },
}));

export const CompanyDisplay: React.FC<{
  values: CompanyForm;
  expand?: boolean;
}> = ({ values, expand = true }) => {
  const classes = useStyles();

  return (
    <div className={classes.formContainer}>
      <Collapse in={expand} timeout="auto" unmountOnExit>
        <DetailTextDisplay
          field={MembershipFormFields.shared.companyName}
          value={values.companyName}
        />
        <DetailTextDisplay
          field={MembershipFormFields.shared.englishName}
          value={values.englishName}
        />
        <DetailTextDisplay
          field={MembershipFormFields.shared.corporateNumber}
          value={values.corporateNumber}
        />
        <DetailTextDisplay field={MembershipFormFields.shared.zipcode} value={values.zipcode} />
        <DetailTextDisplay field={MembershipFormFields.shared.address1} value={values.address1} />
        <DetailTextDisplay field={MembershipFormFields.shared.address2} value={values.address2} />
        <DetailTextDisplay field={MembershipFormFields.shared.phone} value={values.phone} />
        <DetailTextDisplay field={MembershipFormFields.shared.fax} value={values.fax} />
        <DetailTextDisplay field={MembershipFormFields.shared.startDate} value={values.startDate} />
        <MembershipNameTextDisplay
          lastNameField={MembershipFormFields.shared.representerLastName}
          lastName={values.representerLastName}
          firstNameField={MembershipFormFields.shared.representerFirstName}
          firstName={values.representerFirstName}
        />
        <DetailTextDisplay
          field={MembershipFormFields.shared.legalCapital}
          value={values.legalCapital}
        />
        <DetailTextDisplay field={MembershipFormFields.shared.industry} value={values.industry} />
        <DetailTextDisplay
          field={MembershipFormFields.shared.transactionCondition}
          label={
            <>
              {MembershipFormFields.shared.transactionCondition.label}
              <div className={clsx(values.transactionCondition === 'N' && classes.alertDot)} />
            </>
          }
          value={
            values.transactionCondition === 'Y'
              ? values.transactionConditionDetail || membershipFormStrings.transactionCondition
              : values.transactionConditionDetail ||
                membershipFormStrings.transactionConditionInquiry
          }
        />
      </Collapse>
    </div>
  );
};
